/* import __COLOCATED_TEMPLATE__ from './open-loop-gain-inverting.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();